import moment from 'moment';
import 'moment-jdateformatparser';
import { RootState } from 'data/root.reducers';
import { getDiscoverySettingDateFormat, getDiscoverySettingTimeFormat } from 'xcipio/discovery-xcipio-selectors';

/**
 * The date and time formats from Discovery Settings are in Java Date Format and they
 * should be converted to moment format. The function setDateTimeFormat will convert
 * it before caching.
 *
 * The possible date formats in Java Date Format are:
 * - dd/MM/yyyy (11/08/2021)
 * - dd-MMM-yy (11-Aug-21)
 * - M/d/yyyy (8/11/2021)
 * - M/d/yy (8/11/21)
 * - MM/dd/yy (08/11/21)
 * - MM/dd/yyyy (08/11/2021)
 * - yy/MM/dd (21/08/11)
 * - yyyy-MM-dd (2021-08-11)
 *
 * The possible time formats in Java Date Format are:
 * - h:mm tt (2:35 PM)
 * - hh:mm tt (02:35 PM)
 * - H:mm (14:35)
 * - HH:mm (14:35)
 */

const DEFAULT_DATE_FORMAT = 'MM/DD/YY';
const DEFAULT_TIME_FORMAT = 'hh:mm:ss A';
const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;

let dateFormat: string = DEFAULT_DATE_FORMAT;
let timeFormat: string = DEFAULT_TIME_FORMAT;
let dateTimeFormat: string = DEFAULT_DATE_TIME_FORMAT;

/**
 * Caches the date and time format to avoid import loop with the store.
 *
 * @param state the store state
 */
export function setDateTimeFormat(state: RootState): void {
  const jdfDateFormat = getDiscoverySettingDateFormat(state);
  const jdfTimeFormat = getDiscoverySettingTimeFormat(state);

  if (jdfDateFormat !== '') {
    dateFormat = moment().toMomentFormatString(jdfDateFormat);
  }

  if (jdfTimeFormat !== '') {
    timeFormat = moment().toMomentFormatString(jdfTimeFormat);
  }

  if (jdfDateFormat && jdfTimeFormat) {
    dateTimeFormat = `${dateFormat} ${timeFormat}`;
  }
}

export default function getDateTimeFormatTemplate(): string {
  return dateTimeFormat;
}
